export default "__VITE_ASSET__4337439c__"